module.exports = __webpack_public_path__ + "static/media/floor-color.64d187ff.svg";